import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../../utils/TestIds';
import { Row } from '../../../../Layout';
import { Typography } from '../../../../Typography';
import styles from '../cells.module.scss';
import { EditableCell } from '../EditableCell/EditableCell';
import { moneyParts } from './MoneyCell.utils';
export function MoneyCell(param) {
    let { value, unit, openRangeText, emptyText, textSkin, edit, testId } = param;
    var _ref;
    const testIds = getTestIds(testId);
    const amount = moneyParts(value, openRangeText);
    const suffix = unit == null || unit === '' ? null : /*#__PURE__*/ _jsx(Typography, {
        className: styles.unit,
        skin: "secondary",
        ellipsis: true,
        tooltipProps: {
            title: unit
        },
        children: "/ ".concat(unit)
    });
    const price = /*#__PURE__*/ _jsxs(Typography, {
        ellipsis: true,
        weight: "light",
        skin: amount == null ? 'disabled' : textSkin,
        testId: testId,
        children: [
            (_ref = amount === null || amount === void 0 ? void 0 : amount.charged) !== null && _ref !== void 0 ? _ref : emptyText,
            (amount === null || amount === void 0 ? void 0 : amount.beforeDiscount) != null && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    ' ',
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "span",
                        skin: "disabled",
                        textDecoration: "line-through",
                        testId: testIds.beforeDiscount(),
                        children: amount.beforeDiscount
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 4,
        className: styles.money,
        children: [
            edit == null ? price : /*#__PURE__*/ _jsx(EditableCell, {
                edit: edit,
                children: price
            }),
            suffix
        ]
    });
}
